import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { EntityDataDispatcher } from '../entity-data/entity-data.dispatcher';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './client-data.reducer';
import { ClientDataBuilder } from './client-data.builder';
import { ClientDataStore } from './client-data.store';
import { Client } from './client.model';
import {
  clearClientDocuments,
  createClientBankDetails,
  fetchClientDocuments,
  fetchNextClientDocumentsPage,
  filterClientDocuments,
  invoiceClient,
  saveEditingClient,
  sendBankDetailsToEmail,
  showJobDialog,
} from './client-data.actions';
import { DocumentHistoryFilterTypesEnum } from './client-data.data';
import { v4 } from 'uuid';
import { Observable } from 'rxjs';

@Injectable()
export class ClientDataDispatcher extends EntityDataDispatcher<IState, Client> {
  constructor(
    store: Store<any>,
    clientDataStore: ClientDataStore,
    clientDataBuilder: ClientDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      clientDataStore,
      clientDataBuilder,
      globalBannerService,
      translateService
    );
  }

  saveEditingEntity(): Observable<Client | any> {
    const dispatchId = v4();

    this.store.dispatch(saveEditingClient(dispatchId));

    return this.entityDataStore.getDispatchedResponse<Client>(dispatchId);
  }

  invoiceClient(clientId: string) {
    this.store.dispatch(invoiceClient(this.entityType, clientId));
  }

  fetchClientDocuments(
    clientId: string,
    filter: DocumentHistoryFilterTypesEnum = DocumentHistoryFilterTypesEnum.all_documents
  ) {
    this.store.dispatch(
      fetchClientDocuments(this.entityType, clientId, filter)
    );
  }

  fetchNextClientDocumentsPage(clientId: string) {
    this.store.dispatch(
      fetchNextClientDocumentsPage(this.entityType, clientId)
    );
  }

  createBankDetails(clientId: string): Observable<Client> {
    const dispatchId = v4();

    this.store.dispatch(
      createClientBankDetails(dispatchId, this.entityType, clientId)
    );

    return this.entityDataStore.getDispatchedResponse(dispatchId);
  }

  filterClientDocuments(
    clientId: string,
    filter: DocumentHistoryFilterTypesEnum
  ) {
    this.store.dispatch(
      filterClientDocuments(this.entityType, clientId, filter)
    );
  }

  clearClientDocuments() {
    this.store.dispatch(clearClientDocuments(this.entityType));
  }

  sendBankDetailsToEmail(clientId: string, email: string) {
    this.store.dispatch(sendBankDetailsToEmail(clientId, email));
  }

  showJobDialog(flag: boolean) {
    this.store.dispatch(showJobDialog(this.entityType, flag));
  }
}
